<template>
  <div class="footer-widget-edit-wrap">
    <menu-item label="背景设置">
      <menu-fill :target="model.background" target-key="background" />
    </menu-item>
    <menu-item label="PC端背景图">
      <menu-background-image :target="model.background" target-key="background" />
    </menu-item>
    <menu-item label="移动端背景图">
      <menu-background-image :target="model.mobileBackground" target-key="mobileBackground" />
    </menu-item>
    <menu-divider />
    <!-- <menu-item :label="$t('model.footerImage')" size-tip="(建议比例4:2)">
      <menu-background-image :target="model.logoBackground" target-key="logoBackground" />
    </menu-item> -->
    <menu-item class="menu-item-switch" pt="0px" label="字体颜色">
      <menu-fill
        :target="model"
        color-key="footerFontColor"
        eye-key="footerFontColorShow"
        solid-color
      />
    </menu-item>
  </div>
</template>

<script>
import { FooterWidgetModel } from '../../model'
import MenuItem from "~/components/menu/menuItem";
import menuBackgroundImage from "~/components/menu/menuBackgroundImage";
import menuFill from "~/components/menu/menuFill"
import MenuDivider from "~/components/menu/divider.vue";

export default {
  name: "FooterWidgetEdit",
  components: {
    MenuDivider,
    MenuItem,
    menuBackgroundImage,
    menuFill,
  },
  props: {
    site: {
      type: Object,
      default() {
        return {}
      }
    },
    model: {
      type: Object,
      default() {
        return new FooterWidgetModel()
      }
    }
  },
  methods: {
    handleShowBackgroundMenu(key, model) {
      this.$parent && this.$parent.selectSubmenu(key || 'background', model || this.model, {
        imageKey: 'backgroundImage',
        colorKey: ''
      })
    }
  }
}
</script>

<style lang="less" scoped>
.footer-widget-edit-wrap {
  .check {
    span {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.6);
      margin: 0 8px;
    }
  }
}
</style>
